import { render, staticRenderFns } from "./classicDealer.vue?vue&type=template&id=1ad019ae&scoped=true&"
import script from "./classicDealer.vue?vue&type=script&lang=js&"
export * from "./classicDealer.vue?vue&type=script&lang=js&"
import style0 from "./classicDealer.vue?vue&type=style&index=0&id=1ad019ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad019ae",
  null
  
)

export default component.exports